import { ImageAsset } from "@/components/ImageAsset";
import { responsiveImage } from "@/lib/helper";
import { basierCirleBold } from "@/styles/fonts";
import theme from "@/styles/theme";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import { de } from "date-fns/locale";

export default function EventDateBox({ event }) {
  return (
    <Box sx={eventDateBoxStyles} className="event-date-box">
      <Box className="date">
        <Typography className="dateDay">
          {format(new Date(event.date_start), "dd", { locale: de })}
        </Typography>
        <Typography className="dateMonth">
          {format(new Date(event.date_start), "MMM", { locale: de }).replace(
            ".",
            "",
          )}
        </Typography>
      </Box>
      {event.bands?.some((band) => band.photo?.formats) ? (
        event.bands?.map(
          (band) =>
            band.photo?.formats && (
              <Box className="band-image" key={band.id}>
                <Box className="band-image-overlay"></Box>
                <ImageAsset
                  url={responsiveImage(band?.photo?.formats, 600)}
                  layout="fill"
                />
              </Box>
            ),
        )
      ) : (
        <Box className="band-image">
          <Box className="band-image-overlay"></Box>
          <Box
            sx={{
              width: "100%",
              height: "100%",
            }}
          />
        </Box>
      )}
    </Box>
  );
}

const eventDateBoxStyles = {
  position: "relative",

  "& .date": {
    position: "absolute",
    inset: 0,
    zIndex: 20,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  "& .dateMonth": {
    textAlign: "center",
    fontSize: "1rem",
    textTransform: "uppercase",
    color: "white",
    [theme.breakpoints.up("md")]: {
      fontSize: "1.25rem",
    },
  },
  "& .dateDay": {
    textAlign: "center",
    fontSize: "1rem",
    fontFamily: basierCirleBold.style.fontFamily,
    fontWeight: basierCirleBold.style.fontWeight,
    color: "white",
    mb: 1,
    [theme.breakpoints.up("md")]: {
      fontSize: "1.75rem",
    },
  },

  "& .band-image": {
    position: "relative",
    aspectRatio: "1 / 1",
    "& img": {
      filter: "grayscale(100%)",
    },
  },
  "& .band-image-overlay": {
    position: "absolute",
    inset: 0,
    zIndex: 10,
    background:
      "linear-gradient(0deg, rgba(126, 105, 238, 0.8), rgba(126, 105, 238, 0.8)), linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.6) 100%)",
  },
};
